import { render, staticRenderFns } from "./UnassignStudent.vue?vue&type=template&id=dff66e80&scoped=true"
import script from "./UnassignStudent.vue?vue&type=script&lang=js"
export * from "./UnassignStudent.vue?vue&type=script&lang=js"
import style0 from "./UnassignStudent.vue?vue&type=style&index=0&id=dff66e80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff66e80",
  null
  
)

export default component.exports